import { render, staticRenderFns } from "./task_tabs_process.vue?vue&type=template&id=6320d2f0&"
import script from "./task_tabs_process.vue?vue&type=script&lang=js&"
export * from "./task_tabs_process.vue?vue&type=script&lang=js&"
import style0 from "./task_tabs_process.vue?vue&type=style&index=0&id=6320d2f0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports